import React from 'react';
import './StripeSelector.css';

const StripeSelector = ({ items, selectedIndex, onSelect }) => {
  return (
    <div className="stripe-selector-wrapper">
      <div className="stripe-selector" role="tablist" aria-label="Image selector">
        {items.map((item, index) => {
          const isSelected = index === selectedIndex;
          const isAdjacent = index === selectedIndex - 1 || index === selectedIndex + 1;

          let stripeClass = 'stripe';
          if (isSelected) {
            stripeClass += ' stripe--selected';
          } else if (isAdjacent) {
            stripeClass += ' stripe--adjacent';
          }

          return (
            <div
              key={item.id || index}
              role="tab"
              tabIndex={isSelected ? 0 : -1}
              aria-selected={isSelected}
              className={stripeClass}
              onMouseEnter={() => onSelect(index)}
              onKeyDown={(e) => {
                if (e.key === 'ArrowRight') {
                  e.preventDefault();
                  onSelect(Math.min(index + 1, items.length - 1));
                } else if (e.key === 'ArrowLeft') {
                  e.preventDefault();
                  onSelect(Math.max(index - 1, 0));
                }
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default StripeSelector;
